import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { useQueryTable } from "../../misc/components/queryTable/Hooks/UseQueryTable";
import { OverreadStatusIdEnum, QueryCondition, QueryOrderDirection } from "../../misc/api/apiTypes";
import DlcoAnalysisSetList from "./AnalysisSetsList/DlcoAnalysisSetList";
import DlcoSessionListScreen from "./DlcoSessionListScreen";
import { DlcoAnalysisScreen } from "./DlcoAnalysisScreen";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";

export const DlcoRoot = () => {
    const { tableParameters } = useCurrentStudyConfigurationContext();
    
    const analysisSetQueryTableReducer = useQueryTable({
        query: {
            Order: {
                Member: "CreatedDateTime",
                Direction: QueryOrderDirection.Ascending,
            },
            Page: {
                Current: 1,
                Length: tableParameters.DefaultPageSize,
            },
            Filters: [{
                Member: 'StatusId',
                Condition: QueryCondition.Equal,
                Values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted]
            }]
        }
    });

    return (
        <Switch>
            <Route path="/Dlco" exact>
                <DlcoSessionListScreen />
            </Route>
            <Route path="/Dlco/Analysis" exact>
                <DlcoAnalysisSetList queryTableReducer={analysisSetQueryTableReducer} />
            </Route>
            <Route path="/Dlco/Analysis/:analysisSetId/:viewState" component={DlcoAnalysisScreen} />
        </Switch>
    );
}
